import {useState} from 'react';

const useSort = (selected = '') => {

  const [sort, setSort] = useState({ selected });
  
  const handleChangeSort = (e) => {

    const {name, value} = e.target;

    setSort({selected: value})
  }
  

  return {
    sort,
    setSort,
    handleChangeSort
  }
}
export default useSort;